import LayoutSelectors from "@layouts/LayoutSelectors";
import { Grid, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import ModelBaselineEffects from "./components/ModelBaselineEffects";
import ModelKpiBreakdown from "./components/ModelKpiBreakdown";
import ModelKPICalculator from "./components/ModelKPICalculator";
import ModelKpis from "./components/ModelKpis";
import ModelRealPredictedKpi from "./components/ModelRealPredictedKpi";
import ModelResponseCurveChannels from "./components/ModelResponseCurveChannels";
import ModelResponseCurves from "./components/ModelResponseCurves";

const ViewMMModel = () => {
  const [breakdownChannel, setBreakdownChannel] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const marginTop = isMobile || isTablet ? 4 : 0;
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setBreakdownChannel(event.target.checked);
  };

  return (
    <LayoutSelectors>
      <Grid container spacing={4} justifyContent="center">
        <Grid
          size={{ xs: 12, md: 12, sm: 12 }}
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: 2,
            marginLeft: 2,
            marginRight: 2
          }}
        >
          <ModelKpis />
        </Grid>
        <Grid
          size={{ xs: 12, md: 12, sm: 12 }}
          sx={{
            display: "flex",
            justifyContent: "center",
            marginLeft: 2,
            marginRight: 2
          }}
        >
          <Grid container justifyContent="center" className="w-full">
            <Grid
              size={{ xs: 12, sm: 12, md: 12 }}
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: marginTop,
                height: "500px"
              }}
            >
              <ModelRealPredictedKpi />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          size={{ xs: 12, sm: 12, md: 12 }}
          sx={{
            display: "flex",
            justifyContent: "center",
            marginLeft: 2,
            marginRight: 2,
            height: "500px"
          }}
        >
          <ModelBaselineEffects />
        </Grid>
        <Grid
          size={{ xs: 12, sm: 12, md: 12 }}
          sx={{
            display: "flex",
            justifyContent: "center",
            marginLeft: 2,
            marginRight: 2,
            height: "500px"
          }}
        >
          <ModelKpiBreakdown />
        </Grid>
        <Grid
          size={{ xs: 12, sm: 12, md: 12 }}
          sx={{
            display: "flex",
            justifyContent: "center",
            marginLeft: 2,
            marginRight: 2
          }}
        >
          <ModelKPICalculator />
        </Grid>
        {/* <Grid
          size={{ xs: 12, sm: 12, md: 12 }}
          sx={{
            display: "flex",
            justifyContent: "center",
            marginLeft: 2,
            marginRight: 2,
            height: "500px"
          }}
        >
          <ModelMediaContribution />
        </Grid> */}

        <Grid
          size={{ xs: 12, sm: 12, md: 12 }}
          sx={{
            display: "flex",
            justifyContent: "center",
            marginLeft: 2,
            marginRight: 2,
            height: "500px"
          }}
        >
          <ModelResponseCurves
            breakdownChannel={breakdownChannel}
            handleBreakdownChannelChange={handleChange}
          />
        </Grid>
        {breakdownChannel && (
          <Grid
            size={{ xs: 12, sm: 12, md: 12 }}
            sx={{
              display: "flex",
              justifyContent: "center",
              marginLeft: 2,
              marginRight: 2,
              marginBottom: 4
            }}
          >
            <ModelResponseCurveChannels />
          </Grid>
        )}
      </Grid>
    </LayoutSelectors>
  );
};

export default ViewMMModel;
